import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { putMBMIotdevices, deleteMBMIotDevice } from "services/ConfigServices";
import useIotDevicesTable from "./useIotDevicesTable.js";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { iotdevicetext } from "variables/MBM/iotdevices";
import { definitionData, eosprotocoleData } from "variables/MBM/lists/iotdevices";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import IotDialog from "./IotDialog";


const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTIotDevices = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const mbm_admin = permis.includes("mbm_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentIotdevice, setCurrentIotdevice] = useState(null);
  const { gridState, refetch, setIotdevices } = useIotDevicesTable();

  let dataIotdevices = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: iotdevicetext.name,
      selector: (row) => row.name,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.name,
    },
    {
      name: iotdevicetext.deveui,
      selector: (row) => row.connectionproperties.deveui,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.connectionproperties.deveui,
    },
    {
      name: iotdevicetext.definition,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.definition)?.name || ""
    },
    {
      name: iotdevicetext.category,
      selector: (row) => row.definition,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => definitionData.find((x) => x.id == row.definition)?.category || ""
    },
    {
      name: iotdevicetext.eosprotocol,
      selector: (row) => row.connectionproperties.eosprotocol,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => eosprotocoleData.find((x) => x.id == row.connectionproperties?.eosprotocol)?.name || ""
    },
    {
      name: iotdevicetext.lastseen,
      selector: (row) => row.status.lastseenat || 0,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) => row.status?.lastseenat && moment(row.status?.lastseenat).isValid()
        ? moment(row.status?.lastseenat).format("DD/MM/YYYY HH:mm")
        : "",
    },
    {
      name: iotdevicetext.linkmargin,
      selector: (row) => row.status.margin || -255,
      sortable: true,
      maxWidth: "7rem",
      cell: (row) => row.status?.margin ? row.status.margin + ' db' : 'N/A'
    },
    {
      name: iotdevicetext.battery,
      selector: (row) => row.status.deviceStatusbatterylevel || 0,
      sortable: true,
      maxWidth: "7rem",
      cell: (row) => row.status?.externalpowersource === 'true' ? 'AC' :
        row.status?.batterylevelunavailable === 'true' ? 'N/A' :
          row.status?.deviceStatusbatterylevel ? row.status.deviceStatusbatterylevel + '%' : 'N/A'
    },
    {
      name: iotdevicetext.group,
      selector: (row) => row.groupid,
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: "",
      sortable: false,
      width: "10rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>{mbm_admin && (
          <div className="actions-right">
            <Tooltip title="Editer l'IoT">
              <Button
                onClick={editIotdevice(row)}
                color={"warning"}
                className={classes.actionButton}
              >
                <EditIcon fontSize="large" />
              </Button>
            </Tooltip>

            <Tooltip title="Supprimer l'IoT">
              <CustomDeleteButton
                deleteTitle={"Suppression de l'IoT"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer l'IoT' ${row.name}?`}
                handleSupprimer={deleteIotdeviceFunction(row)}
              />
            </Tooltip>

          </div>)}
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editIotdevice = (row) => async () => {
    let obj = dataIotdevices.find((o) => o.id === row.id);
    if (obj) {
      setCurrentIotdevice(obj);
      handleClickOpen();
    }
  }

  const deleteIotdeviceFunction = (row) => async () => {
    let obj = dataIotdevices.find((o) => o.id === row.id);
    let idSelected = obj.id;
    axios
      .delete(deleteMBMIotDevice(idSelected),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'IoT'a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const deleteIotdevicesFunction = (row) => async () => {
    let obj = dataIotdevices.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let selected = [];
    selected.push(idSelected);
    let url = putMBMIotdevices("delete");
    axios
      .put(url,
        {
          iotdevices: selected,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'IoT'a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setIotdevices(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun IoT à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        expandableRowDisabled={(row) => row.disabled}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Edition de {currentIotdevice?.name || ""}
        </CustomDialogTitle>
        <DialogContent dividers>
          <IotDialog
            iot={currentIotdevice}
            closeModal={handleEditClose}
            refetch={refetch}
            setNotification={setNotification}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTIotDevices;
